import { render, staticRenderFns } from "./ItemComments.vue?vue&type=template&id=4c6fa092&scoped=true"
import script from "./ItemComments.vue?vue&type=script&lang=js"
export * from "./ItemComments.vue?vue&type=script&lang=js"
import style0 from "./ItemComments.vue?vue&type=style&index=0&id=4c6fa092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6fa092",
  null
  
)

export default component.exports